import { fmtBRL, fmtInt } from "@/lib/api";
import { Delta, fmtDateBR } from "./biShared";

const fmtPctVal = (v) => `${(Number(v) || 0).toFixed(1).replace(".", ",")}%`;

const HERO = [
  { label: "Faturamento Bruto", key: "gross", fmt: fmtBRL, accent: "text-green-600" },
  { label: "Faturamento Líquido", key: "net", fmt: fmtBRL, accent: "text-green-700" },
  { label: "Pedidos", key: "orders", fmt: fmtInt },
  { label: "Ticket Médio (Bruto)", key: "ticket_gross", fmt: fmtBRL },
];

const ROW2 = [
  { label: "Unidades Vendidas", key: "units", fmt: fmtInt },
  { label: "Copos", key: "cups", fmt: fmtInt },
  { label: "Ticket Líquido", key: "ticket_net", fmt: fmtBRL },
  { label: "Preço Médio / Copo", key: "unit_price_gross", fmt: fmtBRL },
  { label: "Descontos (Bruto → Líquido)", key: "discount_pct", fmt: fmtPctVal, sub: (s) => `${fmtBRL(s.discounts)} no período`, accent: "text-yellow-600" },
  { label: "Comissões / Taxas", key: "fees", fmt: fmtBRL },
  { label: "Frete", key: "freight", fmt: fmtBRL },
  { label: "SKUs Ativos", key: "skus_active", fmt: fmtInt },
];

function Card({ def, summary, growth, hero }) {
  const g = growth?.[def.key];
  const prev = g?.previous;
  return (
    <div className={`tile p-3 ${hero ? "" : ""}`} data-testid={`bi-kpi-${def.key}`}>
      <div className="overline text-[9px] text-zinc-500 truncate" title={def.label}>{def.label}</div>
      <div className={`font-mono font-bold leading-tight ${hero ? "text-2xl" : "text-lg"} ${def.accent || ""}`}>
        {def.fmt(summary?.[def.key] ?? 0)}
      </div>
      <div className="flex items-center gap-2 min-h-[14px]">
        <Delta pct={g?.pct} testid={`bi-kpi-${def.key}-delta`} />
        {def.sub ? (
          <span className="text-[10px] text-zinc-500">{def.sub(summary)}</span>
        ) : (prev !== null && prev !== undefined && (
          <span className="text-[10px] text-zinc-500">ant: {def.fmt(prev)}</span>
        ))}
      </div>
    </div>
  );
}

export default function BiKpiGrid({ data, loading }) {
  if (loading && !data) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="bi-kpi-loading">
        {["a", "b", "c", "d"].map((k) => <div key={k} className="tile p-3 animate-pulse h-[84px]" />)}
      </div>
    );
  }
  if (!data) return null;
  const { summary, growth, period } = data;
  return (
    <div className={`space-y-2 ${loading ? "opacity-60" : ""}`} data-testid="bi-kpi-grid">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {HERO.map((d) => <Card key={d.key} def={d} summary={summary} growth={growth} hero />)}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
        {ROW2.map((d) => <Card key={d.key} def={d} summary={summary} growth={growth} />)}
      </div>
      <div className="text-[10px] text-zinc-500 font-mono" data-testid="bi-period-info">
        Período: {fmtDateBR(period.date_from)} → {fmtDateBR(period.date_to)} · comparado com {fmtDateBR(period.prev_from)} → {fmtDateBR(period.prev_to)}
        {period.compare === "yoy" ? " (ano anterior)" : ""}
      </div>
    </div>
  );
}
